import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import styled from 'styled-components'

export const EditIcon = styled(FontAwesomeIcon)<{ isDisabled?: boolean }>`
  color: ${({ theme: { palette }, isDisabled }) =>
    isDisabled ? palette.primary_200 : palette.primary};
  cursor: ${({ isDisabled }) => (isDisabled ? 'not-allowed' : 'pointer')};
  font-size: 16px;
  transition: all 0.2s ease;

  &:active {
    transform: scale(0.8);
    opacity: 0;
  }
`
